module.exports = __webpack_public_path__ + "static/04-1b9ae1665db57074ea196cc1ac7591a1.jpg";